import {AfterViewInit, Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {User} from './shared/interfaces/user';
import {CommonService} from './core/services/common.service';
import {Router} from '@angular/router';
import {AuthGuard} from './core/services/auth-guard.service';
import {CurrentUserService} from './core/services/current-user.service';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from './core/services/local-storage.service';
import {Subscription} from './shared/interfaces/subscription';

@Component({
    selector: 'ukata-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'Ukata';
  isCollapsed = false;
  displayNavbar: string | undefined;
  @ViewChild('sidenav') sidenav: { toggle: () => void } | undefined;
  user: User | undefined;
  showSidebar = true;
  isLoggedin = false;
  isMaker = false;
  isAdmin = false;
  isMobile = false;
  subscription: Subscription[] = [];
  hasActiveSubscription = true;
  protected readonly CommonService = CommonService;

  constructor(
    private router: Router,
    public authService: AuthGuard,
    private currentUserService: CurrentUserService,
    public translateService: TranslateService,
    private localStorageService: LocalStorageService,
  ) {
    this.isLoggedin = this.authService.isAuthenticated() || false;
    this.isMaker = this.authService.isMaker();
    this.isAdmin = this.authService.isAdmin();
    this.isMobile =
      ('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
      window.innerWidth <= 800;

    this.fetchSubscription();
    const savedLang =
      this.localStorageService.getScalarItem('language') ?? 'en';
    //strip the quotes from savedLang
    translateService.setDefaultLang(savedLang);
    translateService.use(savedLang);
  }

  ngAfterViewInit() {
    const body = document.getElementsByTagName('body')[0];
    body.addEventListener('click', (event) => {
      this.showSidebar = true;
    });

    //call to get user details if loggedin
    if (this.authService.isAuthenticated()) {
      this.currentUserService.getUserDetails().subscribe({
        next: (userDetails) => {
          this.user = userDetails;
        },
      });
    }
  }

  ngOnInit() {
    this.displayNavbar = '1';
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/']).then((r) => {
      console.log('r', r);
    });
  }

  hideMenu() {
    if (this.isMobile) {
      this.isCollapsed = true;
    }
  }

  private fetchSubscription() {
    if (this.authService.isAuthenticated()) {
      this.currentUserService.getSubscriptions().subscribe({
        next: (subscriptions) => {
          this.subscription = subscriptions;
          this.hasActiveSubscription = subscriptions.some((subscription) => {
            return (
              subscription.status &&
              subscription.status.toLowerCase() === 'active'
            );
          });
        },
      });
    }
  }
}
